<div class="content-container">
  <app-side-navigation class="sidebar"></app-side-navigation>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
